<template>
  <div class="animated fadeIn CheckinDDAT">
    <div class="card">
      <div class="card-header">
        Danh sách check-in
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form ref="myForm" label-position="top" @submit.native.prevent
                :model="mData.tableRules.dataSearch.value" :rules="mData.tableRules.dataSearch.valid">
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Thời điểm check-in" prop="thoi_diem_check_in">
                      <el-date-picker type="date" :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat" v-model="mData.tableRules.dataSearch.value.thoi_diem_check_in
                          " :placeholder="aElement.datepicker.placeholderDate" clearable></el-date-picker>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Tên khách du lịch">
                      <el-autocomplete clearable class="inline-input" v-model="nguoi_check_in"
                        :fetch-suggestions="querySearchNguoiCheckin" placeholder="Nhập từ khóa để tìm kiếm"
                        :trigger-on-focus="false" @select="handleSelectNguoiCheckin" @change="handleSelectNguoiCheckin">
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten.ho_ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Số điện thoại">
                      <el-autocomplete clearable class="inline-input" v-model="dien_thoai"
                        :fetch-suggestions="querySearchPhoneNguoiCheckin" placeholder="Nhập số điện thoại để tìm kiếm"
                        :trigger-on-focus="false" @select="handleSelectPhoneNguoiCheckin"
                        @change="handleSelectPhoneNguoiCheckin">
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.dien_thoai }}</span>
                        </template>
                      </el-autocomplete>



                      <!-- <el-input v-model="dien_thoai" placeholder="Nhập số điện thoại" clearable></el-input> -->
                    </el-form-item>
                  </b-col>
                  <b-col md="3" v-if="aRole('Admin')">
                    <el-form-item label="Điểm đến">
                      <el-autocomplete clearable class="inline-input" v-model="ten_diem_den_an_toan"
                        :fetch-suggestions="querySearchTenDDAT" placeholder="Nhập từ khóa để tìm kiếm"
                        :trigger-on-focus="false" @select="handleSelectTenDDAT" @change="handleSelectTenDDAT">
                        <template slot-scope="{ item }">
                          <span class="link">{{
                            item.thong_tin_chung.ten
                            }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button type="info" v-ladda plain @click="fn_tableSearch()">{{ aLang.c_search }}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row style="margin-bottom: 5px">
          <b-col md="12" sm="12">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
                }}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="460" style="width: 100%" :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }">
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect" />
          <el-table-column prop="thoi_diem_check_in" :sortable="mData.tableRules.allowSorting" label="Thời điểm"
            width="170" :formatter="fn_formatterDatetime" align="center" />
          <el-table-column prop="ten_nguoi_tao" label="Người tạo" min-width="250" />
          <el-table-column prop="ten_nguoi_check_in" label="Khách du lịch" min-width="250" />
          <el-table-column label="Ảnh chủ thẻ" width="70" align="center">
            <template slot-scope="scope">
              <div class="ico" v-if="scope.row.avatar_url" title="Xem chi tiết"
                @click="showDetailImage(scope.row.avatar_url)">
                <i class="fas fa-portrait" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="so_the" label="Số thẻ" width="160" />
          <el-table-column prop="ngay_sinh" label="Ngày sinh" width="150" align="center" />
          <el-table-column prop="gioi_tinh" align="center" label="Giới tính" width="130" />
          <el-table-column prop="so_giay_to" label="CMND/CCCD/Hộ chiếu" width="160" />
          <el-table-column label="Mặt trước" width="80" align="center">
            <template slot-scope="scope">
              <div class="ico" v-if="scope.row.anh_cmnd_mat_truoc" title="Xem chi tiết"
                @click="showDetailImage(scope.row.anh_cmnd_mat_truoc)">
                <i class="fas fa-address-card" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Mặt sau" width="80" align="center">
            <template slot-scope="scope">
              <div class="ico" v-if="scope.row.anh_cmnd_mat_sau" title="Xem chi tiết"
                @click="showDetailImage(scope.row.anh_cmnd_mat_sau)">
                <i class="fas fa-address-card" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="dia_chi" label="Địa chỉ" min-width="250" />
          <el-table-column prop="dien_thoai" label="Số điện thoại" width="130" />
          <el-table-column prop="email" label="Email" min-width="200" />
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
            <el-button @click="fn_exportExcelCheckIn()" type="primary" icon="el-icon-download" plain
              v-if="aRole('Admin, SafePlace')">
              Tải danh sách
            </el-button>
          </div>
          <div class="col-md-8 text-right pagination-wrap">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>

    <!-- Dialog chi tiết ảnh -->
    <el-dialog title="Chi tiết" :visible.sync="imageDialogVisible" width="40%" :before-close="handleCloseImageDialog"
      :close-on-click-modal="false">
      <div>
        <el-image :src="urlImageDetail" fit="contain" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import CheckinDDATModel from "./CheckinDDATModel";
import CheckinDDATApi from "../../../moduleApi/CheckinDDATApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import config from "../../../config.json";
import ProfileApi from "../../../moduleApi/ProfileApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
export default {
  components: {
    //
  },
  data() {
    return {
      imageDialogVisible: false,
      urlImageDetail: undefined,
      nguoi_check_in: "",
      dien_thoai: "",
      ten_diem_den_an_toan: "",
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      circleUrlInfo:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        currentUser: MethodService.getCurrentUser(),
        moduleName: "CheckinDDAT", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(CheckinDDATModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listDDAT: [],
          listImplementationObject: DataService.implementationObject,
          listNguoiCheckin: [],
          listNguoiTao: [],
          listNguoiTaoKDL: [],
          listFindNguoiCheckin: [],
          listFindDDAT: [],
          currentUser: {},
          dataExport: [],
          qrcodeId: "",
          linkApp: {},
          listUserCheckIn: [],
          Checkin: {
            viewMode: "create",
            indexModal: undefined,
          },
          Qrcode: {
            viewMode: "create",
            indexModal: undefined,
          },
          Taiapp: {
            viewMode: "create",
            indexModal: undefined,
          },
          QRCode: "",
          dataForeignerQr: null,
          profileVisa: null,
          profileNhapCanh: null,
          dataQrKhachDuLich: null,
          tieu_chi: null,
        },
        dataForm: MethodService.copyObject(CheckinDDATModel.dataForm),
        dataSafeplace: undefined,
        validForm: CheckinDDATModel.validForm,
        dataFormCheckin: MethodService.copyObject(
          CheckinDDATModel.dataFormOther.check_in
        ),
        validFormCheckin: CheckinDDATModel.validFormOther.check_in,
        dialog: {
          Checkin: false,
          Qrcode: false,
          HDDGDDAT: false,
          Taiapp: false,
          scan: false,
          modalUser: false,
          modalInfo: false,
        },
        configChart: {
          title: "",
          titleX: "Ngày",
          titleY: "Số lượt",
          dataPoint: [],
        },
      },
    };
  },
  computed: {
    getModalInfo() {
      return this.mData.dialog.modalInfo;
    },
    getModalUser() {
      return this.mData.dialog.modalUser;
    },
    stringStrim(str) {
      return str.strim();
    },
  },
  watch: {
    getModalInfo() {
      this.checkBody();
    },
    getModalUser() {
      this.checkBody();
    },
  },
  methods: {
    showDetailImage(urlImage) {
      this.imageDialogVisible = true;
      this.urlImageDetail = urlImage;
    },
    handleCloseImageDialog() {
      this.imageDialogVisible = false;
      setTimeout(() => {
        this.urlImageDetail = undefined;
      }, 500);
    },

    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => { });
      }

      let res = await CheckinDDATApi.list(dataFilter);

      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(CheckinDDATModel.dataForm),
        res.result
      );
      let ddatIds = MethodService.findListItemDifferent(
        resData,
        "diem_den_an_toan_id"
      );
      let nguoitaoIds = MethodService.findListItemDifferent(
        resData,
        "nguoi_tao_id"
      );
      let nguoiCheckin = MethodService.findListItemDifferent(resData, 'nguoi_check_in_id')

      Promise.all([
        DiemDenAnToanApi.list({
          limit: ddatIds.length,
          filters: "id:in:" + ddatIds.join(","),
        }),
        KhachDuLichApi.list({
          limit: nguoiCheckin.length,
          filters: "id:in:" + nguoiCheckin.join(","),
        }),
        ProfileApi.list({
          limit: nguoitaoIds.length,
          filters: "id:in:" + nguoitaoIds.join(","),
        }),
        KhachDuLichApi.list({
          limit: nguoitaoIds.length,
          filters: "id:in:" + nguoitaoIds.join(","),
        }),
      ]).then((response) => {
        this.mData.dataDefault.listDDAT = response[0].result;
        this.mData.dataDefault.listNguoiCheckin = response[1].result;
        this.mData.dataDefault.listNguoiTao = response[2].result;
        this.mData.dataDefault.listNguoiTaoKDL = response[3].result;

        setTimeout(() => {
          let resDataAfterChange = this.fn_changeData(resData);
          this.mData.tableRules.data = resDataAfterChange;
          this.mData.tableRules.total = res.meta.total;
          this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
          if (
            this.mData.tableRules.offset == res.meta.total &&
            this.mData.tableRules.offset != 0
          ) {
            this.mData.tableRules.offset = 0;
            this.mData.tableRules.page = 1;
            this.fn_initTable();
          }
        }, 1000);
      });
    },
    fn_changeData(resData) {
      resData.forEach((item) => {
        let diemDenAnToan = this.mData.dataDefault.listDDAT.find((element) => {
          return element.id == item.diem_den_an_toan_id;
        });
        if (diemDenAnToan) {
          item.ten_dien_dien_an_toan = diemDenAnToan.thong_tin_chung.ten;
        } else {
          item.ten_dien_dien_an_toan = "";
        }

        let nguoiCheckin = this.mData.dataDefault.listNguoiCheckin.find(
          (element) => {
            return element.id == item.nguoi_check_in_id;
          }
        );
        if (nguoiCheckin) {
          if (
            nguoiCheckin.ho_ten &&
            nguoiCheckin.ho_ten.ho_ten &&
            nguoiCheckin.ho_ten.ho_ten.trim() != ""
          ) {
            item.ten_nguoi_check_in = nguoiCheckin.ho_ten.ho_ten;
          } else {
            item.ten_nguoi_check_in = "Chưa có thông tin";
          }
          if (nguoiCheckin.dien_thoai) {
            item.dien_thoai = nguoiCheckin.dien_thoai;
          } else {
            item.dien_thoai = "Chưa có thông tin";
          }
          if (nguoiCheckin.so_the) {
            item.so_the = nguoiCheckin.so_the;
          } else {
            item.so_the = "Chưa có thông tin";
          }
          if (nguoiCheckin.avatar_url) {
            item.avatar_url = config.imageUrl + nguoiCheckin.avatar_url;
          }
          if (nguoiCheckin.anh_cmnd) {
            if (nguoiCheckin.anh_cmnd.mat_truoc)
              item.anh_cmnd_mat_truoc = config.imageUrl + nguoiCheckin.anh_cmnd.mat_truoc;
            if (nguoiCheckin.anh_cmnd.mat_sau)
              item.anh_cmnd_mat_sau = config.imageUrl + nguoiCheckin.anh_cmnd.mat_sau;
          }
          if (nguoiCheckin.ngay_sinh && nguoiCheckin.ngay_sinh.ngay_sinh) {
            item.ngay_sinh = MethodService.formatDate(
              nguoiCheckin.ngay_sinh.ngay_sinh,
              "date"
            );
          } else {
            item.ngay_sinh = "Chưa có thông tin";
          }
          if (nguoiCheckin.gioi_tinh) {
            item.gioi_tinh =
              nguoiCheckin.gioi_tinh == 1
                ? "Nữ"
                : nguoiCheckin.gioi_tinh == 2
                  ? "Nam"
                  : nguoiCheckin.gioi_tinh == 3
                    ? "Chưa có thông tin"
                    : nguoiCheckin.gioi_tinh == 4
                      ? "Khác"
                      : "";
          } else {
            item.gioi_tinh = "Chưa có thông tin";
          }
          if (
            nguoiCheckin.giay_to &&
            nguoiCheckin.giay_to.length > 0 &&
            nguoiCheckin.giay_to[0].so_giay_to
          ) {
            item.so_giay_to = nguoiCheckin.giay_to[0].so_giay_to;
          } else {
            item.so_giay_to = "Chưa có thông tin";
          }
          if (nguoiCheckin.dia_chi && nguoiCheckin.dia_chi.dia_chi) {
            item.dia_chi = nguoiCheckin.dia_chi.dia_chi;
          } else {
            item.dia_chi = "Chưa có thông tin";
          }
          if (nguoiCheckin.email) {
            item.email = nguoiCheckin.email;
          } else {
            item.email = "Chưa có thông tin";
          }
        } else {
          item.ten_nguoi_check_in = "Chưa có thông tin";
          item.dien_thoai = "Chưa có thông tin";
          item.ngay_sinh = "Chưa có thông tin";
          item.gioi_tinh = "Chưa có thông tin";
          item.so_giay_to = "Chưa có thông tin";
          item.dia_chi = "Chưa có thông tin";
          item.email = "Chưa có thông tin";
        }

        let nguoiTao = this.mData.dataDefault.listNguoiTao.find((element) => {
          return element.id == item.nguoi_tao_id;
        });
        if (nguoiTao) {
          if (
            nguoiTao.ho_ten &&
            nguoiTao.ho_ten.ho_ten &&
            nguoiTao.ho_ten.ho_ten.trim() != ""
          ) {
            item.ten_nguoi_tao = nguoiTao.ho_ten.ho_ten;
          } else {
            item.ten_nguoi_tao = "Chưa có thông tin";
          }
        } else {
          let nguoiTaoKDL = this.mData.dataDefault.listNguoiTaoKDL.find(
            (element) => {
              return element.id == item.nguoi_tao_id;
            }
          );
          if (nguoiTaoKDL) {
            if (
              nguoiTaoKDL.ho_ten &&
              nguoiTaoKDL.ho_ten.ho_ten &&
              nguoiTaoKDL.ho_ten.ho_ten.trim() != ""
            ) {
              item.ten_nguoi_tao = nguoiTaoKDL.ho_ten.ho_ten;
            } else {
              item.ten_nguoi_tao = "Chưa có thông tin";
            }
          } else {
            item.ten_nguoi_tao = "Chưa có thông tin";
          }
        }
      });
      return resData;
    },
    async fn_getDataExport() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = 1000000;
      }
      let res = await CheckinDDATApi.list(dataFilter);
      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(CheckinDDATModel.dataForm),
        res.result
      );
      let ddatIds = MethodService.findListItemDifferent(
        resData,
        "diem_den_an_toan_id"
      );
      let nguoitaoIds = MethodService.findListItemDifferent(
        resData,
        "nguoi_tao_id"
      );
      Promise.all([
        DiemDenAnToanApi.list({
          limit: ddatIds.length,
          filters: "id:in:" + ddatIds.join(","),
        }),
        KhachDuLichApi.list({
          limit: this.mData.dataDefault.listUserCheckIn.length,
          filters: "id:in:" + this.mData.dataDefault.listUserCheckIn.join(","),
        }),
        ProfileApi.list({
          limit: nguoitaoIds.length,
          filters: "id:in:" + nguoitaoIds.join(","),
        }),
        KhachDuLichApi.list({
          limit: nguoitaoIds.length,
          filters: "id:in:" + nguoitaoIds.join(","),
        }),
      ]).then((response) => {
        this.mData.dataDefault.listDDAT = response[0].result;
        this.mData.dataDefault.listNguoiCheckin = response[1].result;
        this.mData.dataDefault.listNguoiTao = response[2].result;
        this.mData.dataDefault.listNguoiTaoKDL = response[3].result;
        setTimeout(() => {
          let resDataAfterChange = this.fn_changeData(resData);
          MethodService.exportExcelCheckinDDAT(resDataAfterChange);
        });
      });
    },
    async fn_exportExcelCheckIn() {
      this.fn_getDataExport();
    },

    //event table
    async querySearchNguoiCheckin(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }
      let resNguoiCheckin = await KhachDuLichApi.list({
        filters: ["ho_ten.ho_ten:regex_i:" + this.nguoi_check_in],
      });
      let findNguoiCheckin = resNguoiCheckin.result.filter((item) => {
        return (
          item.ho_ten &&
          item.ho_ten.ho_ten &&
          item.ho_ten.ho_ten.toLowerCase().indexOf(queryString.toLowerCase()) >
          -1
        );
      });

      var results = queryString
        ? findNguoiCheckin.filter((item) =>
          item.ho_ten.ho_ten.toLowerCase().includes(queryString.toLowerCase())
        )
        : findNguoiCheckin;
      this.mData.tableRules.dataSearch.value.nguoi_check_in_id = "";
      cb(results);
    },
    handleSelectNguoiCheckin(item) {
      this.mData.tableRules.dataSearch.value.nguoi_check_in_id = item.id;
      this.nguoi_check_in =
        item.ho_ten && item.ho_ten.ho_ten && item.ho_ten.ho_ten
          ? item.ho_ten.ho_ten
          : "";
    },
    async querySearchPhoneNguoiCheckin(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }
      let resNguoiCheckin = await KhachDuLichApi.list({
        filters: ["dien_thoai:regex_i:" + this.dien_thoai],
      });
      let findPhoneNguoiCheckin = resNguoiCheckin.result.filter((item) => {
        return (
          item.dien_thoai &&
          item.dien_thoai.indexOf(queryString) >
          -1
        );
      });

      var results = queryString
        ? findPhoneNguoiCheckin.filter((item) =>
          item.dien_thoai.includes(queryString)
        )
        : findPhoneNguoiCheckin;
      this.mData.tableRules.dataSearch.value.dien_thoai = "";
      cb(results);
    },
    handleSelectPhoneNguoiCheckin(item) {
      this.mData.tableRules.dataSearch.value.nguoi_check_in_id = item.id;
      this.dien_thoai = item.dien_thoai || ""
    },
    async querySearchTenDDAT(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }
      let resDDAT = await DiemDenAnToanApi.list({
        limit: 1000,
        filters: `thong_tin_chung.ten:regex_i:${queryString}`,
      });
      if (resDDAT.result && resDDAT.result.length > 0) {
        this.mData.dataDefault.listFindDDAT = resDDAT.result;
      }
      var results = queryString
        ? this.mData.dataDefault.listFindDDAT.filter((item) =>
          item.thong_tin_chung.ten
            .toLowerCase()
            .includes(queryString.toLowerCase())
        )
        : this.mData.dataDefault.listFindDDAT;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectTenDDAT(item) {
      this.mData.tableRules.dataSearch.value.diem_den_an_toan_id = item.id;
      this.ten_diem_den_an_toan =
        item.thong_tin_chung && item.thong_tin_chung.ten
          ? item.thong_tin_chung.ten
          : "";
    },
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";

          this.fn_initTable();
          // this.fn_getDataExport();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router
        .push({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: query,
        })
        .catch(() => { });
    },
    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },
    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.mData.tableRules.dataSearch.value.nguoi_check_in_id) {
        let resProfile = await KhachDuLichApi.findById(
          this.mData.tableRules.dataSearch.value.nguoi_check_in_id
        );
        if (resProfile.result) {
          console.log('thong tin ng check in', resProfile.result);

          this.mData.dataDefault.listFindNguoiCheckin.push(resProfile.result);
          this.nguoi_check_in =
            this.mData.dataDefault.listFindNguoiCheckin[0].ho_ten.ho_ten;
        }
      }
      if (this.mData.tableRules.dataSearch.value.diem_den_an_toan_id) {
        let resDDATApi = await DiemDenAnToanApi.findById(
          this.mData.tableRules.dataSearch.value.diem_den_an_toan_id
        );
        if (resDDATApi.result) {
          this.ten_diem_den_an_toan = resDDATApi.result.thong_tin_chung.ten;
        }
      }
    },
    checkBody() {
      if (this.mData.dialog.modalUser || this.mData.dialog.modalInfo) {
        $("body").css("overflow", "hidden");
      }
    },
    myEventHandler() {
      this.calcStyle();
    },
    calcStyle() {
      let bgHeight = this.$refs.bg.clientHeight;
      let bgWidth = bgHeight / 1.41;
      const qrWidth = bgWidth * 0.2;
      this.cssStyle.bgWidth = bgWidth + "px";
      this.cssStyle.qrWidth = `${Math.floor(bgWidth / 6.3)}px`;
      this.cssStyle.qrHeight = bgHeight / 5.3;
      this.cssStyle.qrPosionLeft = `${Math.floor(
        (bgWidth - qrWidth) / 1.38
      )}px`;
      this.cssStyle.qrPosionTop = `${Math.floor((bgHeight - qrWidth) / 1.9)}px`;
    },
  },
  async mounted() {
    await this.fn_hashUrl();
    await this.fn_initTable();
    window.scroll({
      top: 1,
    });
    window.scroll({
      top: 0,
    });
    window.removeEventListener("resize", this.myEventHandler);
    window.removeEventListener("scroll", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
    window.removeEventListener("scroll", this.myEventHandler);
  },
};
</script>

<style lang="scss">
.cell {
  .ico {

    .fas,
    .far {
      font-size: 22px;
    }

    &:hover {
      cursor: pointer;
    }
  }
}

.el-autocomplete.inline-input {
  width: 100%;
}

.qr-code img {
  margin: 0 auto;
}

.qr_code_wrap>div,
.qr_code_download>div {
  min-width: 18rem !important;
}

.scroll-bar::-webkit-scrollbar {
  width: 0;
}

.el-dialog__header {
  border-bottom: 1px solid #fff;
  background: #fff;
}

.el-dialog__headerbtn {
  margin-top: 5px;
}

.el-avatar-d>img {
  width: 100%;
}

@media only screen and (max-width: 577.98px) {
  .pagination-wrap {
    text-align: left !important;
  }

  .el-pagination {
    &__total {
      position: absolute;
      left: 1rem;
    }

    &__sizes {
      margin-left: 4rem;
      display: block !important;
      margin-bottom: 0.5rem;
    }

    &__jump {
      position: absolute;
      right: 1rem;
      top: 5px;
    }
  }

  //bug canvas
  .canvasjs-chart-toolbar {
    display: none;
  }
}

.card-body-custom {
  height: calc(100vh - 250px);
}

.card-body-custom>* {
  height: 100%;
}

.bg-qr {
  display: flex;
  height: 100%;
  width: 100%;
  font-size: 10px;
}

#check-in-ddat-qr .el-dialog {
  width: 30%;
  margin: 0 auto 0;
}

@media (min-width: 1012px) and (max-width: 1296px) {
  .button_wrap {
    max-width: 60%;
  }
}

@media (min-width: 991px) and (max-width: 1011px) {
  .button_wrap {
    max-width: 65%;
  }
}

@media (min-width: 720px) and (max-width: 879px) {
  .button_wrap {
    max-width: 67%;
  }
}

@media (min-width: 615px) and (max-width: 719px) {
  .button_wrap {
    max-width: 80%;
  }
}

@media (max-width: 486px) {
  .button_wrap {
    max-width: 70%;
  }

  .tai_app,
  .huong_dan {
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
</style>
